import React, { Component, Fragment } from "react";
import simpleRestClient from "ra-data-simple-rest";
import { ptBrTranslation } from "./ptBrTranslation";
import polyglotI18nProvider from "ra-i18n-polyglot";
import smartlookClient from "smartlook-client";
import { Admin, Resource, fetchUtils, CustomRoutes } from "react-admin";

import packageInfo from "../package.json";
import addUploadFeature from "./addUploadFeature";
import { SERVER_URL, SMARTLOOK_KEY } from "./config";
import authProvider from "./authProvider";
import { theme } from "./theme";
import "./App.css";

import MyLayout from "./MyLayout";

import { AdList, AdCreate, AdEdit } from "./lists/Ads";
import { OrderList, OrderCreate } from "./lists/Orders";
import { SurveyList, SurveyCreate, SurveyEdit } from "./lists/Surveys";
import { CycleList } from "./lists/Cycles";
import CycleZipDownload from "./lists/CycleZipDownload";
import LuftExport from "./lists/LuftExport";
import { CycleLogisticsSendHistoryList } from "./lists/CycleLogisticSendHistory";
import { ConsolidatedDeliveredOrdersList, ConsolidatedDeliveredOrdersCreate } from "./lists/ConsolidatedDeliveredOrders";

import { GroupsList, GroupsCreate, GroupsEdit } from "./lists/Groups";
import { LabList, LabCreate, LabEdit } from "./lists/Labs";
import { PanelList, PanelCreate, PanelEdit } from "./lists/Panels";
import { KitList, KitCreate, KitEdit } from "./lists/Kits";
import { SampleList, SampleCreate, SampleEdit } from "./lists/Samples";
import { SectorList, SectorCreate } from "./lists/Sectors";
import { ProjectList, ProjectCreate, ProjectEdit } from "./lists/Projects";
import { KitImport} from "./lists/KitImport";

import { UserList, UserCreate, UserEdit, UserDelete, UsersWithConfirmedBoxList } from "./lists/Users";
import { TypeUserList } from "./lists/TypeUser";
import {
  RepresentativeList,
  RepresentativeCreate,
  RepresentativeEdit,
} from "./lists/Representatives";
import { AddressesList, AddressCreate } from "./lists/Adresses";

import { FeedbacksList } from "./lists/Feedbacks";
import { AnswerList } from "./lists/Answers";
import { MessageList } from "./lists/Messages";
import { ReviewsList } from "./lists/Reviews";

import { OptinList } from "./lists/OptInUsers";
import { OptOutList } from "./lists/OptOutUsers";

import { BrowserRouter, Route } from "react-router-dom";
import { NfeSampleUploadCreate, NfeSampleUploadList } from "./lists/NfeSampleUpload";
class App extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    smartlookClient.init(SMARTLOOK_KEY);
  }

  render() {
    const httpClient = async (url, options = {}) => {
      if (!options.headers) {
        options.headers = new Headers({ Accept: "application/json" });
      }
      const token = localStorage.getItem("token");

      options.headers.set("Authorization", `Bearer ${token}`);

      const response = await fetchUtils.fetchJson(url, options).catch((error) => {
        throw error;
      });

      return response;
    };

    const restClient = simpleRestClient(SERVER_URL, httpClient);

    const uploadCapableDataProvider = addUploadFeature(restClient);

    const i18nProvider = polyglotI18nProvider(() => ptBrTranslation, "pt", {
      allowMissing: true,
    });

    if (!restClient) {
      return (
        <div className="loader-container">
          <div className="loader">Loading...</div>
        </div>
      );
    }

    return (
      <Fragment>
        <BrowserRouter>
          <Admin
            theme={theme}
            layout={MyLayout}
            locale="pt"
            i18nProvider={i18nProvider}
            dataProvider={uploadCapableDataProvider}
            authProvider={authProvider}
          >
            <CustomRoutes >
              <Route path="/download/cycle" element={<CycleZipDownload />} />
            </CustomRoutes>

            <Resource 
            name="orders/nfe-uploads" 
            list={NfeSampleUploadList} 
            create={NfeSampleUploadCreate}
            options={{ label: "Importação de Nota Fiscal" }} 
            />

            <Resource
            name="cycles-logistics-send-history"
            list={CycleLogisticsSendHistoryList}
            create={LuftExport}
            options={{ label: "Envio de Pedidos" }}
            />

            <Resource name="cycles" list={CycleList} options={{ label: "Ciclo" }} />
            <Resource
              name="consolidated-delivered-orders"
              list={ConsolidatedDeliveredOrdersList}
              create={ConsolidatedDeliveredOrdersCreate}
              options={{ label: "Integração CRM Farma" }}
            />

            <Resource name="address/type-address" />

            <Resource
              name="orders"
              list={OrderList}
              create={OrderCreate}
              options={{ label: "Pedidos" }}
            />

            <Resource
              name="ads"
              create={AdCreate}
              list={AdList}
              edit={AdEdit}
              options={{ label: "Anúncios" }}
            />

            <Resource
              name="groups"
              list={GroupsList}
              create={GroupsCreate}
              edit={GroupsEdit}
              options={{ label: "Grupos" }}
            />

            <Resource
              name="labs"
              list={LabList}
              create={LabCreate}
              edit={LabEdit}
              options={{ label: "Laboratórios" }}
            />

            <Resource
              name="surveys"
              list={SurveyList}
              create={SurveyCreate}
              edit={SurveyEdit}
              options={{ label: "Pesquisas" }}
            />

            <Resource
              name="panels"
              list={PanelList}
              create={PanelCreate}
              edit={PanelEdit}
              options={{ label: "Paineis" }}
            />

            <Resource
              name="kits"
              list={KitList}
              create={KitCreate}
              edit={KitEdit}
              options={{ label: "Kits" }}
            />

            <Resource
              name="samples"
              list={SampleList}
              create={SampleCreate}
              edit={SampleEdit}
              options={{ label: "Amostras" }}
            />

            <Resource
              name="sectors"
              list={SectorList}
              create={SectorCreate}
              options={{ label: "Setores" }}
            />

            <Resource
              name="kitImport"
              list={KitImport}
              options={{ label: "Importação de kit" }}
            />

            <Resource
              name="users"
              list={UserList}
              create={UserCreate}
              edit={UserEdit}
              remove={UserDelete}
              options={{ label: "Usuários" }}
            />

            <Resource
              name="type-users"
              list={TypeUserList}
              options={{ label: "Tipos de Usuário" }}
            />

            <Resource
              name="representatives"
              list={RepresentativeList}
              create={RepresentativeCreate}
              edit={RepresentativeEdit}
              options={{ label: "Representantes" }}
            />

            <Resource
              name="addresses"
              list={AddressesList}
              create={AddressCreate}
              options={{ label: "Endereços" }}
            />

            <Resource
              name="feedbacks"
              list={FeedbacksList}
              options={{ label: "Feedbacks" }}
            />

            <Resource name="answers" list={AnswerList} options={{ label: "Respostas" }} />

            <Resource
              label="Mensagens"
              name="messages"
              list={MessageList}
              options={{ label: "Mensagens" }}
            />

            <Resource
              options={{ label: "Entregas Confirmadas" }}
              name="users-with-confirmed-box"
              list={UsersWithConfirmedBoxList}
            />

            <Resource
              options={{ label: "Avaliações" }}
              name="reviews"
              list={ReviewsList}
            />

            <Resource
              options={{ label: "Autorizado" }}
              name="opt-in-users"
              list={OptinList}
            />
            <Resource
              options={{ label: "Recusado" }}
              name="opt-out-users"
              list={OptOutList}
            />
            <Resource
              options={{ label: "Projetos" }}
              name="projects"
              list={ProjectList}
              create={ProjectCreate}
              edit={ProjectEdit}
            />

          </Admin>
        </BrowserRouter>
        <div
          style={{
            background: "#222",
            fontFamily: "Roboto Condensed Regular",
            color: "white",
            textAlign: "center",
            padding: 30,
          }}
        >
          RX PRO DATA | V{packageInfo.version}
        </div>
      </Fragment>
    );
  }
}

export default App;
